import Viewer from 'miew-react';
import LiH from './LiH.mol2';
import CH3F from './CH3F.xyz';
import F2 from './F2.mol2';
import React, { useEffect, useState } from 'react';

const style = {
  width: '465px',
  height: '423px',
};

function MoleculeViewer(props) {

  const [customOptions, setCustomOptions] = useState({
    load: LiH,
    reps: [
      {
        mode: 'BS',
        colorer: 'EL',
        material: 'DF',
      },
    ],
    // optional settings
    settings: {
      palette: 'VM',
      bg: { color: 0xffffff },
      fogFarFactor: 2,
      fps: false,
      axes: false,
      resolution: 'high',
    },
  });


  useEffect(() => {
    if (props.molecule == 'LiH') {
      setCustomOptions({
        ...customOptions,
        load: LiH,
        settings:{
          palette: 'VM',
          bg: { color: 0xffffff },
          fogFarFactor: 2,
          fps: false,
          axes: false,
          resolution: 'high',
        }
      });
      const canvas = document.querySelector('canvas');
      const gl = canvas.getContext('webgl');
      // console.log("canvas object:" + canvas);
      // console.log("canvas camera object:" + canvas.camera);
      // console.log("canvas gl camera object:" + gl);
      // console.log("canvas gl camera object:" + gl.VIEWPORT);
      gl.enable(gl.DEPTH_TEST);



    }
    if (props.molecule == 'F2') {
      setCustomOptions({
        ...customOptions,
        load: F2,
        settings:
        {
          palette: 'JM',
          bg: { color: 0xffffff },
          fogFarFactor: 2,
          fps: false,
          axes: false,
          resolution: 'high',
      }
      });
      const canvas = document.querySelectorAll('canvas').length;

    }
    if (props.molecule == 'CH3F') {
      setCustomOptions({
        ...customOptions,
        load: CH3F,
        settings:{      palette: 'JM',
              bg: { color: 0xffffff },
              fogFarFactor: 2,
              fps: false,
              axes: false,
              resolution: 'high',}
      });
    }
  }, [props.molecule]);

  return (
    <>
      <div className='molecule-viewer' >
        <div className='miew-container' style={style} >
          <Viewer options={customOptions} />
        </div>
      </div>
    </>
  );
}

export default MoleculeViewer;
